import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-6" }
const _hoisted_5 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_6 = { class: "col-md-6" }
const _hoisted_7 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_8 = { class: "col-md-12" }
const _hoisted_9 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_12 = { class: "col-md-6" }
const _hoisted_13 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_16 = { class: "col-md-6" }
const _hoisted_17 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_18 = { class: "col-md-6" }
const _hoisted_19 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_20 = { class: "col-md-6" }
const _hoisted_21 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_22 = { class: "col-md-6" }
const _hoisted_23 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_24 = { class: "col-md-6" }
const _hoisted_25 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_26 = { class: "col-md-4" }
const _hoisted_27 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_28 = { class: "col-md-12" }
const _hoisted_29 = { class: "d-flex align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Field = _resolveComponent("Field")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Form, { onSubmit: _ctx.editProduitRestreint }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[12] || (_cache[12] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Type de restriction "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Multiselect, {
                  options: _ctx.restrictionTypeOptions,
                  searchable: true,
                  "track-by": "value",
                  label: "label",
                  modelValue: _ctx.formData.restriction_type,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.restriction_type) = $event)),
                  "value-prop": "value",
                  object: true,
                  placeholder: "Sélectionner le type de restriction"
                }, null, 8, ["options", "modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "restriction_type",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _cache[13] || (_cache[13] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Pays "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Multiselect, {
                  options: _ctx.paysOptions,
                  searchable: true,
                  "track-by": "value",
                  label: "label",
                  object: true,
                  modelValue: _ctx.formData.pays,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.pays) = $event)),
                  placeholder: "Sélectionner le pays"
                }, null, 8, ["options", "modelValue"])
              ]),
              _createVNode(_component_ErrorMessage, {
                name: "pays",
                class: "text-danger"
              })
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _cache[14] || (_cache[14] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Description "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "description",
                  as: "textarea",
                  rows: "2",
                  class: "form-control shadow-none fs-md-15 text-black",
                  modelValue: _ctx.formData.description,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.description) = $event)),
                  placeholder: "Description..."
                }, null, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "description",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _cache[15] || (_cache[15] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Type de document ", -1)),
                _createVNode(_component_Multiselect, {
                  options: _ctx.typeDOptions,
                  searchable: true,
                  object: true,
                  "track-by": "value",
                  label: "label",
                  modelValue: _ctx.formData.typeD,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.typeD) = $event)),
                  placeholder: "Sélectionner le type de document"
                }, null, 8, ["options", "modelValue"])
              ]),
              _createVNode(_component_ErrorMessage, {
                name: "typeD",
                class: "text-danger"
              })
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _cache[16] || (_cache[16] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Hs Code ", -1)),
                _createVNode(_component_Multiselect, {
                  options: _ctx.hscodeOptions,
                  searchable: true,
                  "track-by": "value",
                  label: "label",
                  object: true,
                  modelValue: _ctx.formData.hscode,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.hscode) = $event)),
                  placeholder: "Sélectionner le hscode"
                }, null, 8, ["options", "modelValue"])
              ]),
              _createVNode(_component_ErrorMessage, {
                name: "hscode",
                class: "text-danger"
              })
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _cache[17] || (_cache[17] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Catégorie Produit ", -1)),
                _createVNode(_component_Multiselect, {
                  options: _ctx.categorieProduitOptions,
                  searchable: true,
                  "track-by": "value",
                  label: "label",
                  modelValue: _ctx.formData.categorieProduit,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.categorieProduit) = $event)),
                  object: true,
                  placeholder: "Sélectionner la categorie de Produit"
                }, null, 8, ["options", "modelValue"])
              ]),
              _createVNode(_component_ErrorMessage, {
                name: "categorieProduit",
                class: "text-danger"
              })
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _cache[18] || (_cache[18] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Régime Douanier ", -1)),
                _createVNode(_component_Multiselect, {
                  options: _ctx.regimeDouanierOptions,
                  searchable: true,
                  "track-by": "value",
                  label: "label",
                  modelValue: _ctx.formData.regimeDouanier,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.regimeDouanier) = $event)),
                  object: true,
                  placeholder: "Sélectionner le régime"
                }, null, 8, ["options", "modelValue"])
              ]),
              _createVNode(_component_ErrorMessage, {
                name: "regimeDouanier",
                class: "text-danger"
              })
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _cache[19] || (_cache[19] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Quantité maximale", -1)),
                _createVNode(_component_Field, {
                  name: "max_quantity",
                  type: "number",
                  class: "form-control",
                  modelValue: _ctx.formData.max_quantity,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.max_quantity) = $event)),
                  placeholder: "Quantité maximale autorisée"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "max_quantity",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _cache[20] || (_cache[20] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Valeur maximale", -1)),
                _createVNode(_component_Field, {
                  name: "max_declared_value",
                  type: "number",
                  class: "form-control",
                  modelValue: _ctx.formData.max_declared_value,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.max_declared_value) = $event)),
                  placeholder: "Valeur maximale autorisée"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "max_declared_value",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _cache[21] || (_cache[21] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Date de début d'application de cette restriction. ", -1)),
                _createVNode(_component_Field, {
                  name: "effective_from",
                  type: "date",
                  modelValue: _ctx.formData.effective_from,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.effective_from) = $event)),
                  class: "form-control shadow-none fs-md-15 text-black"
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _cache[22] || (_cache[22] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Date de fin d'application éventuelle ", -1)),
                _createVNode(_component_Field, {
                  name: "effective_to",
                  modelValue: _ctx.formData.effective_to,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.effective_to) = $event)),
                  type: "date",
                  class: "form-control shadow-none fs-md-15 text-black"
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _cache[23] || (_cache[23] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Activer", -1)),
                _createVNode(_component_Field, {
                  name: "is_active",
                  type: "checkbox",
                  class: "form-check-input",
                  modelValue: _ctx.formData.is_active,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.is_active) = $event)),
                  value: true,
                  "unchecked-value": false
                }, null, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "is_active",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _cache[25] || (_cache[25] = _createElementVNode("button", {
                  type: "submit",
                  class: "default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success"
                }, " Modifier le produit ", -1)),
                _createVNode(_component_router_link, {
                  to: "/listeProduitRestreint",
                  class: "btn btn-danger transition border-0 lh-1 fw-medium"
                }, {
                  default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                    _createElementVNode("i", { class: "flaticon-delete lh-1 me-1 position-relative top-2" }, null, -1),
                    _createElementVNode("span", { class: "position-relative" }, null, -1),
                    _createTextVNode("Annuler ", -1)
                  ]))]),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit"])
    ])
  ]))
}